import Arrow from 'assets/images/arrows/arrowLeft.svg?react';
import { Link } from 'react-router-dom';
import './styles.scss';

interface PreMatchTrackerArrowProps {
	direction: 'left' | 'right';
	link: string;
}

const PreMatchTrackerArrow = ({ direction, link }: PreMatchTrackerArrowProps) => (
	<Link to={link} className={`preMatchTrackerArrow preMatchTrackerArrow--${direction}`}>
		<Arrow />
	</Link>
);
export default PreMatchTrackerArrow;
